export function mustEnv(property) {
    const value = import.meta.env[property];
    if (typeof value === 'undefined') {
        if (process.env.NODE_ENV === 'test')
            return '';
        throw new Error(`process.env.${property} has not been set`);
    }
    return value;
}
